import debug from 'debug';
import isMobile from 'ismobilejs';
import _ from 'lodash';
import Helmet from 'react-helmet';
import { v4 as uuidv4 } from 'uuid';
import { sizes } from 'components/responsive';
import firebaseProvider from './analytics.firebase';
import gaProvider from './analytics.ga';
import snowplowProvider from './analytics.snowplow';
import { isBrowser } from './platform';
const LOG = debug('analytics');
function ensureDeviceId(request) {
    const COOKIE_KEY = '_swc_did';
    let cookies, deviceId;
    if (process.browser) {
        cookies = require('cookies-js');
    }
    else if (request) {
        cookies = request.cookies;
        if (request._deviceId) {
            return request._deviceId;
        }
    }
    if (!cookies) {
        return;
    }
    deviceId = cookies.get(COOKIE_KEY);
    LOG('Get deviceId:', deviceId);
    if (!deviceId) {
        deviceId = uuidv4();
        const expires = new Date();
        expires.setTime(expires.valueOf() + 2 * 365 * 24 * 60 * 60 * 1000);
        cookies.set(COOKIE_KEY, deviceId, { expires, path: '/', httpOnly: false });
        if (request) {
            request._deviceId = deviceId;
        }
    }
    return deviceId;
}
const PROVIDERS = [gaProvider(ensureDeviceId), firebaseProvider(ensureDeviceId), snowplowProvider(ensureDeviceId)];
const init = (request) => {
    LOG('Init');
    PROVIDERS.map((provider) => provider.init(request));
};
const track = async (...args) => {
    args[2] = addCommonParams(args[2]);
    try {
        await Promise.all(PROVIDERS.map((provider) => provider.track(...args)));
    }
    catch (error) {
        LOG('Failed to track:', error);
    }
    LOG('Event:', ...args);
};
const pageview = async (...args) => {
    args[1] = addCommonParams(args[1]);
    try {
        await Promise.all(PROVIDERS.map((provider) => provider.pageview(...args)));
    }
    catch (error) {
        LOG('Failed to pageview:', error);
    }
    LOG('Pageview:', ...args);
};
const setUserProperties = (properties) => {
    PROVIDERS.forEach((provider) => {
        if (typeof provider.setUserProperties !== 'function')
            return;
        try {
            provider.setUserProperties(properties);
        }
        catch (error) {
            LOG('Failed to setUserProperties:', error);
        }
    });
};
// Params every event carries. Page events pass `title` in themselves; for the rest we read it
// from the same place they do, so an event reports the title of the page it fired on.
function addCommonParams(args = {}) {
    // TODO Fix analytics for server side (pass useragent to isMobile)
    if (!isBrowser) {
        return args;
    }
    const isHome = args.page === '/';
    let windowSize = {};
    if (isHome) {
        windowSize = {
            isMultiscreen: window.innerWidth < sizes.desktop,
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
        };
    }
    let platform;
    const device = isMobile();
    if (device.apple.device) {
        platform = 'Apple';
    }
    else if (device.amazon.device) {
        platform = 'Amazon';
    }
    else if (device.android.device) {
        platform = 'Android';
    }
    else if (device.windows.device) {
        platform = 'Windows';
    }
    else if (device.any) {
        platform = 'Other';
    }
    else {
        platform = 'PC';
    }
    return Object.assign(Object.assign(Object.assign({}, args), { title: args.title || Helmet.peek().title, platform, isMobile: _.get(device, 'any', undefined), userAgent: _.get(navigator, 'userAgent', undefined) }), windowSize);
}
export default {
    init,
    track,
    pageview,
    setUserProperties,
};
